import React from 'react';
import Layout from '../components/layout';
import ContentContainer from '../components/content-container';

const Disclaimer = () => {
  const heading = 'Legal Disclaimer';

  const content = (
    <p>
      Graasp Insights (the &lsquo;software&rsquo;) and its source code are
      freely distributed under the GNU Affero General Public License (AGPLv3).
      The software and source code are provided to you “as is”, without warranty
      of any kind, express or implied. Without limiting the generality of the
      foregoing, the Graasp Association and École Polytechnique Fédérale de
      Lausanne (EPFL) make no representation or warranty regarding the
      functionality, reliability, or performance of the software, or the results
      to be obtained through the use of the software, or that the operation of
      the software shall be error-free. In no event shall the Graasp Association
      or EPFL be liable for any damages arising from the use of Graasp Insights,
      including but not limited to the distribution, misuse, leakage, or theft
      of any original files or datasets or duplicates thereof handled,
      processed, or generated by the software.
    </p>
  );

  return (
    <Layout>
      <ContentContainer heading={heading} content={content} />
    </Layout>
  );
};

export default Disclaimer;
